import React from "react";
import Text from "../UI/Text";
import Widget from "../UI/Widget";
import List from "../UI/List";
import LI from "../UI/List/Item";
// import { Link } from "react-router-dom";
// import Logo from "../../assets/img/logo-dark.png";
import Logo from "../../assets/img/kangaroo-care-new-logo.png";
import ServicesList from "../../data/Services/allservices.json";

import SocialLink from "../../templates/Contact/SocialLink";

function Footer() {
  const pathname = window.location.pathname;

  const CenterLinks = [
    "/centre/bangalore",
    "/centre/mysore",
    "/centre/fertility-center/bengaluru",
    "/centre/kangaroo-care-dentistry",
    "/centre/kangaroo-care-clinics-nagarabhavi",
    "/centre/kangaroo-care-clinics-banashankari",
    "/centre/kangaroo-care-ramanagara",
    "/centre/fertility-center-mysore",
    "/centre/fertility-center-ramanagara",
    "/centre/tumakuru",
  ];
  // console.log("start");
  // console.log(pathname);
  // console.log(CenterLinks);
  // console.log(CenterLinks.includes(pathname));
  // console.log();
  // console.log("end");

  // if () {
  //   console.log("found");
  // }
  if (pathname == "/centre/bangalore") {
    console.log("done");
    console.log(pathname == "/centre/bangalore");
  }
  console.log();
  return (
    <footer className="footer-area">
      <div className="container">
        <div className="row mtn-40">
          <div className="col-lg-4 order-4 order-lg-0">
            <div className="widget-item">
              <div className="about-widget">
                <a
                  title="Kangaroo Care - Women & Child Hospital"
                  href={`${process.env.PUBLIC_URL + "/"}`}
                >
                  {/* <img src={Logo} alt="Logo" /> */}
                  <img
                    src="/images/kc-logo-header.png"
                    alt="Kangaroo Care - Women & Child Hospital"
                    className="img-fluid"
                  />
                </a>

                {/* <Text>
                  Kangaroo Care is a Women and Children Hospitals in Bangalore,
                  Mysore, Ramanagara and Tumakuru. We are supported with
                  top-rated doctors and equipped with advanced infrastructure.
                </Text> */}

                {/* <h5 className="ts30">
                  <h3 style={{ fontSize: " 1.25rem" }}></h3>
                  Trusted by <strong>20000+</strong> Families{" "}
                </h5> */}
              </div>
            </div>

            <div className="download_app_box_container">
              <h3>Download Our App On</h3>
              <div id="download_app_text" className="download_app_box_new">
                <div>
                  <img src="/kc_qr.png" alt="kc qr" />
                </div>
                <div className="download_app">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=au.com.turntech.kangaroocare&hl=en_US"
                  >
                    <img src="/download_app.png" alt="download app" />
                  </a>
                  <a
                    target="_blank"
                    href="https://apps.apple.com/in/app/kangaroo-care/id1634423573"
                  >
                    <img src="/appstore-webp.webp" alt="appstore" />
                  </a>
                </div>
              </div>
              <h3 style={{ fontSize: " 1.25rem" }} className="ts30">
                Trusted by <strong>30000+</strong> Families{" "}
              </h3>
              <h4 className="corporate-office-heading">
Kangaroo Care Corporate Office:
</h4>
              <p>
  3rd & 4th Floor, 7, 53rd Cross Rd, 3rd Block,
  Rajajinagar, Bengaluru, Karnataka 560010
</p>
            </div>
            {/* <div className="info-foot">
              <div className="row ts20 ">
                <div className="col-1 hide-mobile">
                  <i className="fa fa-envelope contact-icon"></i>
                </div>
                <div className="col-10">
                  <a
                    href="mailto:info@kangaroocareindia.com"
                    className="basetext"
                  >
                    info@kangaroocareindia.com
                  </a>
                </div>
              </div>
              <div className="row ts20">
                <div className="col-1 hide-mobile">
                  <i className="fa fa-phone contact-icon"></i>
                </div>
                <div className="col">
                  <div className="row">
                    <div className="col-10">
                      <a
                        title=" 1800-425-4500"
                        href="tel:1800-425-4500"
                        className="basetext  Footer1_phonenumber"
                      >
                        Toll Free &nbsp; 1800-425-4500
                      </a>
                    </div>
                    <div className="col-5">
                        <a
                          title="+91 8296688887"
                          href="tel:+918296688887"
                          className="basetext"
                        >
                          +91 8296688887
                        </a>
                      </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div className="col-12 col-lg-1"></div>

          {/* <div className="col-md-4 col-lg-2 ml-auto"></div> */}

          <div className="col-md-4 col-lg-2 ml-auto">
            <Widget title="Important Links">
              <List classes="widget-list">
                {/* <LI>
                  <a title="Home" href={`${process.env.PUBLIC_URL + "/"}`}>
                    Home
                  </a>
                </LI>
                <LI>
                  <a
                    title="About"
                    href={`${process.env.PUBLIC_URL + "/about"}`}
                  >
                    About
                  </a>
                </LI>
                <LI>
                  <a
                    title="Our Journey"
                    href={`${process.env.PUBLIC_URL + "/about/our-journey"}`}
                  >
                    Our Journey
                  </a>
                </LI>
                <LI>
                  <a
                    title="Facilities"
                    href={`${process.env.PUBLIC_URL + "/gallery/facilities"}`}
                  >
                    Facilities
                  </a>
                </LI>
                <LI>
                  <a
                    title="Gallery"
                    href={`${process.env.PUBLIC_URL + "/gallery"}`}
                  >
                    Gallery
                  </a>
                </LI>
                <LI>
                  <a title="KATS" href={`${process.env.PUBLIC_URL + "/kats"}`}>
                    KATS
                  </a>
                </LI>
                <LI>
                  <a title="Blogs" href={`${process.env.PUBLIC_URL + "/blog"}`}>
                    Blogs
                  </a>
                </LI>
                <LI>
                  <a
                    title="FAQs"
                    href={`${process.env.PUBLIC_URL + "/media/faqs"}`}
                  >
                    FAQs
                  </a>
                </LI>
                <LI>
                  <a
                    title="Careers"
                    href={`${process.env.PUBLIC_URL + "/careers"}`}
                  >
                    Careers
                  </a>
                </LI>
                <LI>
                  <a
                    title="Sitemap"
                    href={`${process.env.PUBLIC_URL + "/sitemap"}`}
                  >
                    Sitemap
                  </a>
                </LI>
                <LI>
                  <a
                    title="Privacy Policy"
                    href={`${
                      process.env.PUBLIC_URL + "/policy/privacy_policy"
                    }`}
                  >
                    Privacy Policy
                  </a>
                </LI> */}
                <LI>
                  <a
                    title="Terms & Conditions"
                    href={`${
                      process.env.PUBLIC_URL + "/policy/Terms_&_Conditions"
                    }`}
                  >
                    Terms & Conditions
                  </a>
                </LI>
                <LI>
                  <a
                    title="Privacy Policy"
                    href={`${
                      process.env.PUBLIC_URL + "/policy/privacy_policy"
                    }`}
                  >
                    Privacy Policy
                  </a>
                </LI>
              </List>
            </Widget>
          </div>

          <div className="col-12 col-lg-3 ml-auto">
            <Widget title="Services">
              <List classes="widget-list">
                {ServicesList.map(
                  ({ id, link, title, footerTitle = "", showInFooter }) =>
                    showInFooter && (
                      <LI key={id}>
                        {footerTitle && (
                          <a title={title} href={link}>
                            {footerTitle}
                          </a>
                        )}
                      </LI>
                    )
                )}
              </List>
              {/* <Widget className="" title="Follow Us On">
                <SocialLink socialClass={"member-social-icons-footer"} />
              </Widget> */}
            </Widget>
            {/* <h3 style={{ fontSize: " 1.25rem" }} className="ts30">
              {" "}
              Trusted by <strong>30000+</strong> Families{" "}
            </h3> */}
          </div>

          <div className="col ml-auto">
            {!CenterLinks.includes(pathname) ||
              pathname == "/centre/bangalore" ||
              pathname == "/centre/mysore"}

            {(pathname == "/centre/bangalore" ||
              pathname == "/centre/fertility-center/bengaluru") && (
              <>
                <Widget title="Bangalore Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon footer-contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #89, 17th cross, MC layout, Near Balagangadharnath Swamy
                        Metro Station, Vijayanagar, Bangalore 560040.
                      </div>
                    </div>

                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext  Footer1_phonenumber"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                          <div className="col-5">
                        <a
                          title="+91 8296688887"
                          href="tel:+918296688887"
                          className="basetext"
                        >
                          +91 8296688887
                        </a>
                      </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                </Widget>
                <div className="row ts20 ">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-envelope contact-icon footer-contact-icon"></i>
                  </div>
                  <div className="col-10">
                    <a
                      href="mailto:info@kangaroocareindia.com"
                      className="basetext"
                    >
                      info@kangaroocareindia.com
                    </a>
                  </div>
                </div>
                <div className="row ts20">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-phone contact-icon footer-contact-icon"></i>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-10">
                        <a
                          title=" 1800-425-4500"
                          href="tel:1800-425-4500"
                          className="basetext  Footer1_phonenumber"
                        >
                          Toll Free &nbsp; 1800-425-4500
                        </a>
                      </div>
                      {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                    </div>
                  </div>
                </div>
                {/* <div className="col-12">
                  <SocialLink socialClass={"member-social-icons-footer "} />
                </div> */}
              </>
            )}
            {pathname == "/centre/kangaroo-care-ramanagara" && (
              <>
                {" "}
                <Widget title="Ramanagara Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        No.32 of Vivekanandanagar, Block-3, North B.M. Road,
                        Ramanagara -562 159 Karnataka
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone fa-rotate-90 contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title="1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                </Widget>
                {/* <div className="col-12">
                  <SocialLink socialClass={"member-social-icons-footer "} />
                </div> */}
                <div className="row ts20 ">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-envelope contact-icon"></i>
                  </div>
                  <div className="col-10">
                    <a
                      href="mailto:info@kangaroocareindia.com"
                      className="basetext"
                    >
                      info@kangaroocareindia.com
                    </a>
                  </div>
                </div>
                <div className="row ts20">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-phone contact-icon"></i>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-10">
                        <a
                          title=" 1800-425-4500"
                          href="tel:1800-425-4500"
                          className="basetext  Footer1_phonenumber"
                        >
                          Toll Free &nbsp; 1800-425-4500
                        </a>
                      </div>
                      {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                    </div>
                  </div>
                </div>
              </>
            )}
            {pathname == "/centre/mysore" && (
              <>
                {" "}
                <Widget title="Mysore Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #505, Kalidasa road, Vijayanagar 1st stage, Opp. MUDA
                        Complex, Mysore - 570017.
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone fa-rotate-90 contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                </Widget>
                {/* <div className="col-12">
                  <SocialLink socialClass={"member-social-icons-footer "} />
                </div> */}
                <div className="row ts20 ">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-envelope contact-icon"></i>
                  </div>
                  <div className="col-10">
                    <a
                      href="mailto:info@kangaroocareindia.com"
                      className="basetext"
                    >
                      info@kangaroocareindia.com
                    </a>
                  </div>
                </div>
                <div className="row ts20">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-phone contact-icon"></i>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-10">
                        <a
                          title=" 1800-425-4500"
                          href="tel:1800-425-4500"
                          className="basetext  Footer1_phonenumber"
                        >
                          Toll Free &nbsp; 1800-425-4500
                        </a>
                      </div>
                      {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                    </div>
                  </div>
                </div>
              </>
            )}
            {pathname == "/centre/tumakuru" && (
              <>
                {" "}
                <Widget title="Tumakuru Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #6136, Ring Road, Maralur, Saraswathipuram -Tumakuru
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone fa-rotate-90 contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                </Widget>
                {/* <div className="col-12">
                  <SocialLink socialClass={"member-social-icons-footer "} />
                </div> */}
                <div className="row ts20 ">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-envelope contact-icon"></i>
                  </div>
                  <div className="col-10">
                    <a
                      href="mailto:info@kangaroocareindia.com"
                      className="basetext"
                    >
                      info@kangaroocareindia.com
                    </a>
                  </div>
                </div>
                <div className="row ts20">
                  <div className="col-1 hide-mobile">
                    <i className="fa fa-phone contact-icon"></i>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col-10">
                        <a
                          title=" 1800-425-4500"
                          href="tel:1800-425-4500"
                          className="basetext  Footer1_phonenumber"
                        >
                          Toll Free &nbsp; 1800-425-4500
                        </a>
                      </div>
                      {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                    </div>
                  </div>
                </div>
              </>
            )}

            {!CenterLinks.includes(pathname) && (
              <>
                <Widget title="Our Centers">
                  <address>
                    <a href="/centre/bangalore" className="basetext">
                      <div className="d-flex align-items-center">
                        <div className="">
                          {/* <i className="fa fa-map-marker contact-icon"></i> */}
                          {/* <div> */}
                          {/* <img
                            src="/images/locations/bangalore_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                          {/* </div> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Bangalore
                        </div>
                      </div>
                    </a>
                    <a href="/centre/mysore" className="basetext">
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/mysore_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Mysore
                        </div>
                      </div>
                    </a>
                    <a
                      href="/centre/kangaroo-care-ramanagara"
                      className="basetext "
                    >
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/ramanagara_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Ramanagara
                        </div>
                      </div>
                    </a>

                    <a href="/centre/tumakuru" className="basetext ">
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/tumakuru_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Tumakuru
                        </div>
                      </div>
                    </a>
                    <a
                      href="https://kangaroocarefertility.com/"
                      className="basetext "
                    >
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/tumakuru_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Fertility Centers
                        </div>
                      </div>
                    </a>
                    <a href="/centre/kangaroo-care-kids" className="basetext ">
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/tumakuru_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Kangaroo Care Kids
                        </div>
                      </div>
                    </a>
                    <a
                      href="/centre/kangaroo-care-clinics-nagarabhavi"
                      className="basetext "
                    >
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/tumakuru_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Kangaroo Care Clinic - Nagarabhavi
                        </div>
                      </div>
                    </a>
                    <a
                      href="/centre/kangaroo-care-clinics-banashankari"
                      className="basetext "
                    >
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/tumakuru_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Kangaroo Care Clinic - Banashankari
                        </div>
                      </div>
                    </a>
                    <a
                      href="/centre/kangaroo-care-dentistry"
                      className="basetext "
                    >
                      <div className="d-flex align-items-center my-2">
                        <div className="">
                          {/* <img
                            src="/images/locations/tumakuru_small.png"
                            style={{ width: "40px", marginLeft: "auto" }}
                          /> */}
                        </div>
                        <div
                          className="mx-2"
                          style={{ fontSize: "16px", fontWeight: "600" }}
                        >
                          Kangaroo Care Dentistry
                        </div>
                      </div>
                    </a>
                    {/* <ul>
                      <li>Bangalore</li>
                    </ul> */}
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                          <div className="col-5">
                        <a
                          title="+91 8296688887"
                          href="tel:+918296688887"
                          className="basetext"
                        >
                          +91 8296688887
                        </a>
                      </div>
                        </div>
                      </div>
                    </div> */}
                  </address>

                  <div className="row ts20 ">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-envelope contact-icon"></i>
                    </div>
                    <div className="col-10">
                      <a
                        href="mailto:info@kangaroocareindia.com"
                        className="basetext"
                      >
                        info@kangaroocareindia.com
                      </a>
                    </div>
                  </div>
                 <div className="row ts20">
  <div className="col-1 hide-mobile">
    <i className="fa fa-phone contact-icon phone-icon-correct"></i>
  </div>

  <div className="col">
    <div className="row">
      <div className="col-10">
        <a
          title="1800-425-4500"
          href="tel:1800-425-4500"
          className="basetext Footer1_phonenumber"
        >
          Toll Free &nbsp; 1800-425-4500
        </a>
      </div>

      {/* <div className="col-5">
        <a
          title="+91 8296688887"
          href="tel:+918296688887"
          className="basetext"
        >
          +91 8296688887
        </a>
      </div> */}
    </div>
  </div>
</div>

                  {/* <SocialLink socialClass={"member-social-icons-footer"} /> */}
                </Widget>

                {/* <Widget title="Mysore Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #505, Kalidasa road, Vijayanagar 1st stage, Opp. MUDA
                        Complex, Mysore - 570017.
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </address>
                </Widget>

                <Widget title="Ramanagara Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        No.32 of Vivekanandanagar, Block-3, North B.M. Road,
                        Ramanagara -562 159 Karnataka
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </address>
                </Widget> */}
              </>
            )}
            {pathname == "/centre/fertility-center-ramanagara" && (
              <Widget title="Ramanagara Contact Info">
                <address>
                  <div className="row">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-map-marker contact-icon"></i>
                    </div>
                    <div className="col-10 basetext">
                      No.32 of Vivekanandanagar, Block-3, North B.M. Road,
                      Ramanagara -562 159 Karnataka
                    </div>
                  </div>
                  {/* <div className="row ts20">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-envelope contact-icon"></i>
                    </div>
                    <div className="col-10">
                      <a
                        href="mailto:info@kangaroocareindia.com"
                        className="basetext"
                      >
                        info@kangaroocareindia.com
                      </a>
                    </div>
                  </div>
                  <div className="row ts20">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-phone contact-icon"></i>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col-10">
                          <a
                            title=" 1800-425-4500"
                            href="tel:1800-425-4500"
                            className="basetext"
                          >
                            Toll Free &nbsp; 1800-425-4500
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </address>
                <div className="col-12">
                  <SocialLink socialClass={"member-social-icons-footer "} />
                </div>
              </Widget>
            )}
            {pathname == "/centre/kangaroo-care-clinics-nagarabhavi" && (
              <>
                <Widget title="Nagarabhavi Clinic Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #236, 4th cross, RHCS layout, Annapoorneshwari Nagar
                        Main road , Nagarabhavi Bangalore - 560091
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                  {/* <div className="col-12">
                    <SocialLink socialClass={"member-social-icons-footer "} />
                  </div> */}
                  <div className="row ts20 ">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-envelope contact-icon"></i>
                    </div>
                    <div className="col-10">
                      <a
                        href="mailto:info@kangaroocareindia.com"
                        className="basetext"
                      >
                        info@kangaroocareindia.com
                      </a>
                    </div>
                  </div>
                  <div className="row ts20">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-phone contact-icon"></i>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col-10">
                          <a
                            title=" 1800-425-4500"
                            href="tel:1800-425-4500"
                            className="basetext  Footer1_phonenumber"
                          >
                            Toll Free &nbsp; 1800-425-4500
                          </a>
                        </div>
                        {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </Widget>
              </>
            )}
            {pathname == "/centre/fertility-center-mysore" && (
              <>
                <Widget title="Mysore Fertility Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #384, New Kalidasa Road, Opposite Kangaroo Care
                        Hospitals, Vijayanagar, 1st Stage, Mysore - 570017
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                  <div className="col-12">
                    <SocialLink socialClass={"member-social-icons-footer "} />
                  </div>
                </Widget>
              </>
            )}
            {pathname == "/centre/kangaroo-care-clinics-banashankari" && (
              <>
                <Widget title="Banashankari Clinic Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #23, Katriguppa Main Road, Opp. Big Bazar, B.S.K. 3rd
                        Stage, Bangalore-85
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                  {/* <div className="col-12">
                    <SocialLink socialClass={"member-social-icons-footer "} />
                  </div> */}
                  <div className="row ts20 ">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-envelope contact-icon"></i>
                    </div>
                    <div className="col-10">
                      <a
                        href="mailto:info@kangaroocareindia.com"
                        className="basetext"
                      >
                        info@kangaroocareindia.com
                      </a>
                    </div>
                  </div>
                  <div className="row ts20">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-phone contact-icon"></i>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col-10">
                          <a
                            title=" 1800-425-4500"
                            href="tel:1800-425-4500"
                            className="basetext  Footer1_phonenumber"
                          >
                            Toll Free &nbsp; 1800-425-4500
                          </a>
                        </div>
                        {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </Widget>
              </>
            )}

            {pathname == "/centre/kangaroo-care-dentistry" && (
              <>
                <Widget title="Kangaroo Care Dentistry  Contact Info">
                  <address>
                    <div className="row">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-map-marker contact-icon"></i>
                      </div>
                      <div className="col-10 basetext">
                        #119, 8th cross MC Layout,Vijaynagar, Bengaluru
                      </div>
                    </div>
                    {/* <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-envelope contact-icon"></i>
                      </div>
                      <div className="col-10">
                        <a
                          href="mailto:info@kangaroocareindia.com"
                          className="basetext"
                        >
                          info@kangaroocareindia.com
                        </a>
                      </div>
                    </div>
                    <div className="row ts20">
                      <div className="col-1 hide-mobile">
                        <i className="fa fa-phone contact-icon"></i>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="col-10">
                            <a
                              title=" 1800-425-4500"
                              href="tel:1800-425-4500"
                              className="basetext"
                            >
                              Toll Free &nbsp; 1800-425-4500
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </address>
                  {/* <div className="col-12">
                    <SocialLink socialClass={"member-social-icons-footer "} />
                  </div> */}
                  <div className="row ts20 ">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-envelope contact-icon"></i>
                    </div>
                    <div className="col-10">
                      <a
                        href="mailto:info@kangaroocareindia.com"
                        className="basetext"
                      >
                        info@kangaroocareindia.com
                      </a>
                    </div>
                  </div>
                  <div className="row ts20">
                    <div className="col-1 hide-mobile">
                      <i className="fa fa-phone contact-icon"></i>
                    </div>
                    <div className="col">
                      <div className="row">
                        <div className="col-10">
                          <a
                            title=" 1800-425-4500"
                            href="tel:1800-425-4500"
                            className="basetext  Footer1_phonenumber"
                          >
                            Toll Free &nbsp; 1800-425-4500
                          </a>
                        </div>
                        {/* <div className="col-5">
                          <a
                            title="+91 8296688887"
                            href="tel:+918296688887"
                            className="basetext"
                          >
                            +91 8296688887
                          </a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </Widget>
              </>
            )}
          </div>
        </div>
        <Widget className="follow-new" title="Follow Us On">
          <SocialLink socialClass={"member-social-icons-footer"} />
        </Widget>
        <div className="row">
          <div className="mr-auto ts20 footer-text">
            &copy; Copyright 2025. All Rights Reserved. Maintained by{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              title="Team"
              href="https://digikit.in/"
              style={{ color: " rgb(238, 90, 42)" }}
            >
              DIGIKIT
            </a>
            , Partnered by{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              title="Team"
              href="https://turntech.in/"
              style={{ color: " rgb(238, 90, 42)" }}
            >
              Turntech India Pvt Ltd
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
